import React from 'react';
import { Button } from 'react-bootstrap';
import { AltNavBar } from '../components/NavBar';
import Localization from '../localization';

import '../styles/Endorsements.scss';

import config from '../config/web-site.json';

const strings = Localization.getStrings();

const { page, images } = config.endorsements.paiste;

type PaisteProps = {
  scroller: (arg: string) => void;
}

const Paiste: React.FC<PaisteProps> = (props) => {
  const { scroller } = props;

  return (
    <section id='paiste' data-testid='paiste-view'>
    <AltNavBar {...{ scroller, source: config.pages.paiste.title}} className='paiste-nav-bar'/>
      <div className='collage-header-paiste'>
        <img src={require('../assets/img/paiste_logo.png')} alt='Paiste logo' />
        <Button variant='outline-primary' href={page} target='_blank' className='artist-page-button'>{strings.b_visit_artist_page}</Button>
      </div>
      <section className='collage'>
        {images.map((image, index) => (
        <div key={index} className='collage-item'>
          <img src={require(`../assets/img/paiste/${image}`)} alt={`Collage item ${index + 1}`} />
        </div>
        ))}
      </section>
    </section>
  );
};

export default Paiste;